<template>
  <div id="types" class="mb-14 flex w-full flex-col gap-3 p-5 pt-2">
    <div
      v-for="ticketType in types"
      :key="ticketType.id"
      class="border-bdr-subtle shadow-on-top shadow-bgr-secondary flex cursor-pointer gap-4 rounded-lg border p-4"
      @click="$emit('select', ticketType)"
    >
      <div class="space-y-0.5">
        <p class="text-body-default-m">{{ ticketType.name }}</p>
        <p class="text-body-default">{{ ticketType.description }}</p>
      </div>
      <div class="ml-auto flex items-center justify-center">
        <Icon src="arrow_right" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { TicketType } from "~/types/ticket";

  defineProps<{
    types: TicketType[];
  }>();

  defineEmits<{
    select: [type: TicketType];
  }>();
</script>
